// Texto da Política de Privacidade (fornecido pela Alexandra). Mesmo formato de termos.js.
export const PRIVACIDADE = {
  intro: [
    "A presente Política de Privacidade explica de que forma a Babybib trata os dados pessoais dos utilizadores e clientes do website.",
    "A Babybib valoriza a privacidade e procura garantir que os dados pessoais sejam tratados de forma transparente, segura e apenas para finalidades legítimas.",
  ],
  sections: [
    {
      title: "Responsável pelo tratamento",
      body: ["Responsável pelo tratamento: Alexandra Rodrigues / Babybib.pt", "Email: babybib.pt@gmail.com"],
    },
    {
      title: "Que dados pessoais podemos recolher",
      body: [
        "Dependendo da utilização do website, poderão ser recolhidos os seguintes dados:",
        {
          list: [
            "Nome;",
            "Morada de entrega;",
            "Endereço de email;",
            "Número de telefone;",
            "Dados necessários para faturação;",
            "Dados relativos às encomendas;",
            "Informação necessária à personalização dos produtos;",
            "Comunicações trocadas com a Babybib;",
            "Dados técnicos necessários ao funcionamento e segurança do website;",
            "Informação relacionada com a utilização do website, através de cookies e tecnologias semelhantes, quando aplicável.",
          ],
        },
        "A Babybib não solicita dados pessoais que não sejam necessários para as finalidades identificadas.",
      ],
    },
    {
      title: "Para que utilizamos os dados",
      body: [
        "Os dados pessoais podem ser utilizados para:",
        {
          list: [
            "Processar e gerir encomendas;",
            "Produzir artigos personalizados;",
            "Emitir documentos de faturação;",
            "Processar pagamentos;",
            "Preparar e entregar encomendas;",
            "Contactar o cliente relativamente à sua encomenda;",
            "Responder a pedidos de informação;",
            "Gerir reclamações e pedidos de assistência;",
            "Cumprir obrigações legais e fiscais;",
            "Garantir a segurança do website;",
            "Prevenir utilizações fraudulentas ou abusivas;",
            "Analisar a utilização do website quando tal seja realizado através de ferramentas de análise devidamente configuradas.",
          ],
        },
      ],
    },
    {
      title: "Fundamento do tratamento",
      body: [
        "O tratamento dos dados pessoais poderá ter como fundamento:",
        {
          list: [
            "O cumprimento de obrigações legais;",
            "O interesse legítimo da Babybib, quando aplicável;",
            "O consentimento do titular dos dados, quando legalmente exigido.",
          ],
        },
        "O consentimento poderá ser retirado a qualquer momento quando o tratamento se baseie nesse consentimento. A retirada do consentimento não afeta a licitude do tratamento realizado anteriormente.",
      ],
    },
    {
      title: "Dados relativos a pagamentos",
      body: [
        "Quando o pagamento seja realizado através de um prestador externo, os dados necessários ao processamento do pagamento poderão ser tratados diretamente por esse prestador, de acordo com as respetivas políticas de privacidade e condições.",
        "A Babybib não deverá armazenar dados completos de cartões bancários, salvo se existir uma solução de pagamento que o permita legitimamente e que esteja devidamente configurada para esse efeito.",
      ],
    },
    {
      title: "Entrega das encomendas",
      body: [
        "Para efetuar a entrega, poderão ser partilhados com a transportadora os dados estritamente necessários, nomeadamente nome, morada e contacto. Esses dados serão utilizados para permitir a entrega da encomenda.",
      ],
    },
    {
      title: "Prestadores de serviços",
      body: [
        "A Babybib poderá recorrer a prestadores de serviços externos para determinadas tarefas necessárias ao funcionamento da atividade, como:",
        {
          list: [
            "Alojamento e manutenção do website;",
            "Processamento de pagamentos;",
            "Serviços de transporte;",
            "Faturação e contabilidade;",
            "Serviços de email;",
            "Ferramentas de análise e funcionamento do website.",
          ],
        },
        "Quando esses prestadores tratem dados pessoais por conta da Babybib, serão adotadas as medidas e garantias exigidas pela legislação aplicável.",
      ],
    },
    {
      title: "Conservação dos dados",
      body: [
        "Os dados pessoais são conservados apenas durante o período necessário para cumprir as finalidades para as quais foram recolhidos e para cumprir as obrigações legais aplicáveis.",
        "Os dados relacionados com encomendas, faturação e obrigações fiscais poderão ter de ser conservados durante os períodos legalmente exigidos.",
      ],
    },
    {
      title: "Direitos dos titulares",
      body: [
        "Nos termos da legislação aplicável, o titular dos dados poderá exercer, quando aplicável, os seguintes direitos:",
        {
          list: [
            "Direito de acesso;",
            "Direito de retificação;",
            "Direito ao apagamento;",
            "Direito à limitação do tratamento;",
            "Direito de oposição;",
            "Direito à portabilidade;",
            "Direito de retirar o consentimento quando o tratamento tenha por base o consentimento.",
          ],
        },
        "Para exercer os seus direitos, o titular deverá contactar: babybib.pt@gmail.com",
        "O pedido deverá permitir identificar o titular e indicar claramente o direito que pretende exercer.",
      ],
    },
    {
      title: "Reclamação junto da autoridade de controlo",
      body: [
        "O titular dos dados tem o direito de apresentar uma reclamação junto da autoridade de controlo competente. Em Portugal, a autoridade de controlo é a Comissão Nacional de Proteção de Dados (CNPD).",
      ],
    },
    {
      title: "Segurança",
      body: [
        "A Babybib adota medidas técnicas e organizativas adequadas para proteger os dados pessoais contra perda, destruição, alteração, acesso não autorizado ou outras formas de tratamento ilícito.",
        "No entanto, nenhum sistema de transmissão ou armazenamento eletrónico pode garantir segurança absoluta.",
      ],
    },
    {
      title: "Cookies",
      body: [
        "O website utiliza cookies e tecnologias semelhantes. A utilização de cookies poderá permitir o correto funcionamento do website, memorizar determinadas preferências, analisar a utilização do website ou disponibilizar funcionalidades adicionais.",
        "Os cookies que não sejam estritamente necessários serão utilizados de acordo com as regras aplicáveis e, quando necessário, mediante consentimento do utilizador.",
        "Mais informações encontram-se na Política de Cookies da Babybib.",
      ],
    },
    {
      title: "Alterações à Política de Privacidade",
      body: [
        "A Babybib poderá atualizar esta Política de Privacidade sempre que necessário, nomeadamente devido a alterações legais, técnicas ou ao funcionamento do website. A versão atualizada será disponibilizada nesta página.",
      ],
    },
    {
      title: "Contacto",
      body: ["Para qualquer questão relacionada com a proteção de dados pessoais, poderá contactar: Babybib", "Email: babybib.pt@gmail.com"],
    },
  ],
};
